/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map } from 'immutable';
import { putError } from '../store/error.store';
import { RestAPI } from '../util/net';
import { saveFinished, saveInAction } from '../store/allaround.store';

export const PRICE_URL_TYPES = {
  DIRECT: 'DIRECT',
  DROPBOX: 'DROPBOX',
};


const DEFAULT_STORE_NODE_VALUE = Map({
  urlType: PRICE_URL_TYPES.DIRECT,
});

export const pricesDbReducer = (state = DEFAULT_STORE_NODE_VALUE, action) => {
  switch (action.type) {
    case 'PRICES_DATABASE_URL_FETCHED' :
    case 'PRICES_DATABASE_URL_UPDATE_URL' :
    case 'PRICES_DATABASE_URL_SAVED' :
      return state.set('url', action.url);
    case 'PRICES_DATABASE_IMPORT_EXPORT_URL_SAVED':
    case 'PRICES_DATABASE_IMPORT_EXPORT_URL_FETCHED':
    case 'PRICES_DATABASE_IMPORT_EXPORT_URL_UPDATE_URL':
      return state.set('importExportUrl', action.url);
    case 'PRICES_DATABASE_URL_PROCESSING_CHECKED':
    case 'WS_PRICES_DATABASE_URL_PROCESSING_ACTION':
      return state.set('isLoading', action.isActive);
    case 'PRICES_DATABASE_URL_UPDATE_URL_TYPE':
    case 'PRICES_DATABASE_URL_TYPE_FETCHED':
      return state.set('urlType', PRICE_URL_TYPES[action.urlType] ?
        action.urlType : PRICE_URL_TYPES.DIRECT);
    case 'IMPORT_EXPORT_DATABASE_URL_UPDATE_URL_TYPE':
      return state.set('importExportUrlType', PRICE_URL_TYPES[action.urlType] ?
        action.urlType : PRICE_URL_TYPES.DIRECT);
    case 'PRICES_DATABASE_ERROR_FETCHED':
    case 'WS_PRICES_DATABASE_ERROR':
      return state.set('error', action.error);
    case 'PRICES_DATABASE_CLEAR_URL':
      return state.delete('error');
    default:
      return state;
  }
};

const clearError = (dispatch) => dispatch({ type: 'PRICES_DATABASE_CLEAR_URL' });

export const launchImportExportParsing = (dispatch) => {
  dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_LAUNCH_STARTED' });
  clearError(dispatch);
  return RestAPI.get('/pricesdb/api/importexport')
    .then(() => {
      dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_LAUNCHED' });
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_LAUNCH_FAILED' });
      let error = data;
      if (data.exception === 'ru.sggr.starter.deal.prices.IncorrectUrlException') {
        error = {
          alert: true,
          message: 'Incorrect url',
        };
      }
      putError(dispatch, error);
      return true;
    });
};

export const launchParsing = (dispatch) => {
  dispatch({ type: 'PRICES_DATABASE_URL_LAUNCH_STARTED' });
  clearError(dispatch);
  return RestAPI.get('/pricesdb/api/start')
    .then(() => {
      dispatch({ type: 'PRICES_DATABASE_URL_LAUNCHED' });
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_URL_LAUNCH_FAILED' });
      let error = data;
      if (data.exception === 'ru.sggr.starter.deal.prices.IncorrectUrlException') {
        error = {
          alert: true,
          message: 'Incorrect url',
        };
      }
      putError(dispatch, error);
      return true;
    });
};

export const saveUrlType = (dispatch, urlType, startParsing = false) => {
  saveInAction(dispatch);
  dispatch({ type: 'PRICES_DATABASE_URL_TYPE_SAVE_STARTED' });
  return RestAPI.put('/references/systemvalues/api/string?'
      + `variableName=price_url_type&value=${urlType}`)
    .then(() => {
      dispatch({ type: 'PRICES_DATABASE_URL_TYPE_SAVED', urlType });
      if (startParsing) {
        launchParsing(dispatch);
      }
      saveFinished(dispatch);
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_URL_TYPE_SAVE_FAILED' });
      putError(dispatch, data);
      saveFinished(dispatch);
      return true;
    });
};

export const saveImportExportUrlType = (dispatch, urlType, startParsing = false) => {
  saveInAction(dispatch);
  dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_TYPE_SAVE_STARTED' });
  return RestAPI.put('/references/systemvalues/api/string?'
    + `variableName=import_export_url_type&value=${urlType}`)
    .then(() => {
      dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_TYPE_SAVED', urlType });
      if (startParsing) {
        launchImportExportParsing(dispatch);
      }
      saveFinished(dispatch);
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_TYPE_SAVE_FAILED' });
      putError(dispatch, data);
      saveFinished(dispatch);
      return true;
    });
};

export const saveUrl = (dispatch, url, urlType, startParsing = false) => {
  saveInAction(dispatch);
  dispatch({ type: 'PRICES_DATABASE_URL_SAVE_STARTED' });
  return RestAPI.put('/references/systemvalues/api/string'
    + `?variableName=prices_db_url&value=${encodeURI(url)}`)
    .then(() => {
      dispatch({ type: 'PRICES_DATABASE_URL_SAVED', url });
      saveUrlType(dispatch, urlType, startParsing);
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_URL_SAVE_FAILED' });
      putError(dispatch, data);
      saveFinished(dispatch);
      return true;
    });
};

export const saveImportExportUrl = (dispatch, url, urlType, startParsing = false) => {
  saveInAction(dispatch);
  dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_SAVE_STARTED' });
  return RestAPI.put('/references/systemvalues/api/string'
    + `?variableName=import_export_url&value=${encodeURI(url)}`)
    .then(() => {
      dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_SAVED', url });
      saveImportExportUrlType(dispatch, urlType, startParsing);
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_SAVE_FAILED' });
      putError(dispatch, data);
      saveFinished(dispatch);
      return true;
    });
};


export const checkUrlProcessing = (dispatch) => {
  dispatch({ type: 'PRICES_DATABASE_URL_PROCESSING_CHECK_STARTED' });
  return RestAPI.get('/pricesdb/api/isactive')
    .then((isActive) => {
      dispatch({ type: 'PRICES_DATABASE_URL_PROCESSING_CHECKED', isActive });
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_URL_PROCESSING_CHECK_FAILED' });
      putError(dispatch, data);
      return true;
    });
};

export const fetchUrl = (dispatch) => {
  dispatch({ type: 'PRICES_DATABASE_URL_FETCH_STARTED' });
  return RestAPI.get('/references/systemvalues/api/string?variableName=prices_db_url')
    .then((url) => {
      dispatch({ type: 'PRICES_DATABASE_URL_FETCHED', url });
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_URL_FETCH_FAILED' });
      putError(dispatch, data);
      return true;
    });
};

export const fetchImportExportUrl = (dispatch) => {
  dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_FETCH_STARTED' });
  return RestAPI.get('/references/systemvalues/api/string?variableName=import_export_url')
    .then((url) => {
      dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_FETCHED', url });
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_FETCH_FAILED' });
      putError(dispatch, data);
      return true;
    });
};

export const fetchError = (dispatch) => {
  dispatch({ type: 'PRICES_DATABASE_ERROR_FETCH_STARTED' });
  return RestAPI.get('/references/systemvalues/api/string?variableName=price_url_parsing_error')
    .then((error) => {
      dispatch({ type: 'PRICES_DATABASE_ERROR_FETCHED', error });
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_ERROR_FETCH_FAILED' });
      putError(dispatch, data);
      return true;
    });
};

export const fetchUrlType = (dispatch) => {
  dispatch({ type: 'PRICES_DATABASE_URL_TYPE_FETCH_STARTED' });
  return RestAPI.get('/references/systemvalues/api/string?variableName=price_url_type')
    .then((urlType) => {
      dispatch({ type: 'PRICES_DATABASE_URL_TYPE_FETCHED', urlType });
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_URL_TYPE_FETCH_FAILED' });
      putError(dispatch, data);
      return true;
    });
};

export const fetchImportExportUrlType = (dispatch) => {
  dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_TYPE_FETCH_STARTED' });
  return RestAPI.get('/references/systemvalues/api/string?variableName=import_export_url_type')
    .then((urlType) => {
      dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_TYPE_FETCHED', urlType });
      return true;
    },
    (data) => {
      dispatch({ type: 'PRICES_DATABASE_IMpORT_EXPORT_URL_TYPE_FETCH_FAILED' });
      putError(dispatch, data);
      return true;
    });
};

export const updateUrl = (dispatch, url) =>
  dispatch({ type: 'PRICES_DATABASE_URL_UPDATE_URL', url });

export const updateImportExportUrl = (dispatch, url) =>
  dispatch({ type: 'PRICES_DATABASE_IMPORT_EXPORT_URL_UPDATE_URL', url });

export const updateUrlType = (dispatch, type) =>
  dispatch({ type: 'PRICES_DATABASE_URL_UPDATE_URL_TYPE', urlType: type });

export const updateImportExportUrlType = (dispatch, type) =>
  dispatch({ type: 'IMPORT_EXPORT_DATABASE_URL_UPDATE_URL_TYPE', urlType: type });
